import styles from './Form.module.scss';
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import CustomDatePicker from './CustomDatePicker';
import { useCustomEventListener } from 'react-custom-events';
import moment from 'moment';
import { validatePurchasePrice } from '../utils/animalReview';

export default function AnimalForm({
  animal,
  reviewMessage,
  index,
  formProps,
  setItemState,
  itemStateRef,
  onDeleteClick
}) {
  const FIVE_YEARS_IN_DAYS = 365 * 5;
  const { register, trigger,formState: { errors },setError, clearErrors , setValue, getValues} = formProps;
  const purchasePriceMessage = reviewMessage || errors.animals?.[index]?.purchaseprice?.message;

  const breeds = ["","Angus","Charolais","Chianina","Gelbvieh","Hereford","Limousine","Maine","Red Angus","Shorthorn","Simmental","Wagyu","Commercial","Other"];
  const uses = ["","Only Breeding","Only Show","Show/Breeding"];

  const isUniqueLotNo = (newLotNum) => {
    return !getValues().animals.filter((_, animalIndex) => index !== animalIndex).some(animal => animal.lotno === newLotNum);
  }

  function getDOB(){
    const dob = getValues().animals[index].dob;
    let ret = null;
    if(dob){
      if(dob instanceof Date){
        ret = dob;
      } else {
        ret = moment(dob, 'MM/DD/YYYY').toDate();
      }
    } else {
      ret = moment().subtract(90, "days").toDate();
    }
    return ret;
  }


  function checkPrice(value) {
    return validatePurchasePrice(value, getValues('state'), getValues(`animals[${index}].dob`));
  }

  function onSave() {
    if (errors.animals && errors.animals.length > index &&  errors.animals[index]){
      console.log(errors.animals[index]);
    } else {
      setItemState("CLOSED");
      setValue(`animals[${index}].itemState`,"CLOSED");
    }
  }

  async function validateAndSave() {
    if (await trigger()) {
      onSave();
    }
  }

  useCustomEventListener('submit-open-form', () => {
    onSave();
  });

  return (
  <div>
    <fieldset className={styles.light}>

      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <div className={styles.label}>Animal's Name</div>
           <input type="text"  placeholder="Enter name" {...register(`animals[${index}].name` ,
            {
              value: animal.name,
              required: true,
              maxLength: 30
            }
            )}/>

          { errors.animals && errors.animals.length > index && errors.animals[index] && errors.animals[index].name && (
            <div className={styles.error}>Animal name is required</div>
          )}
        </div>

        <div className={styles.field}>
          <div className={styles.label}>Registration No.</div>
          <input type="text" id={`animals[${index}].regno`} placeholder="Enter number" {...register(`animals[${index}].regno`,
            {
              value: animal.regno,
              maxLength: 30
            })}/>
          {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].regno && (
            <div className={styles.error}>Registration number is required</div>
          )}
        </div>
      </div>

      <div className={styles.fieldRow}>
        <div className={styles.twoThirdsField}>
          <div className={styles.label}>Date of Birth</div>
          <CustomDatePicker
            value={getDOB()}
            onChange={(formattedDate) => {
              const dt = moment(formattedDate, 'MM/DD/YYYY').toDate();
              if (moment().diff(dt, "days") < 90) {
                setError(`animals[${index}].dob`, {message: `Minimum age 90 days`});
              } else if (moment().diff(dt, "days") > FIVE_YEARS_IN_DAYS) {
                setError(`animals[${index}].dob`, {message: `Maximum age 5 years`});
              } else {
                clearErrors(`animals[${index}].dob`);
              }
              setValue(`animals[${index}].dob`, formattedDate, { shouldValidate: true });
              trigger(`animals[${index}].purchaseprice`);
            }}
          />
          {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].dob && (
            <div className={styles.error}>{ errors.animals[index].dob.message} </div>
          )}
        </div>

        <div className={styles.oneThirdField}>
          <div className={styles.label}>Gender</div>
          <select id={`animals[${index}].gender`} placeholder="Select gender" {...register(`animals[${index}].gender`, {
            value: animal.gender,
            required: {value: true, message: "Gender required"},
            validate: (value) => (value !== null)
          })}>
            <option value=""/>
            <option value="F">Female</option>
            <option value="M">Male (no steers)</option>
          </select>
          <div className={styles.error}>
            {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].gender && "Gender is required"}
          </div>
        </div>
      </div>

      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <div className={styles.label}>Breed</div>
          <select id={`animals[${index}].breed`} {...register(`animals[${index}].breed`,
            {
              value: animal.breed,
              required: true
            })} >
              {breeds.map(breed => <option key={breed} value={breed} >{breed}</option>) }
            </select>
          {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].breed && (
            <div className={styles.error}>Breed is required</div>
          )}
        </div>

        <div className={styles.field}>
          <div className={styles.label}>Use</div>
          <select id={`animals[${index}].use`} {...register(`animals[${index}].use`,
            {
              value: animal.use,
              required: true
            })} >
            {uses.map(use => <option key={use} value={use} >{use}</option>) }
          </select>
          {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].use && (
            <div className={styles.error}>Use is required</div>
          )}
        </div>

        <div className={styles.quarterField}>
          <div className={styles.label}>Lot No.</div>
          <input type="text" id={`animals[${index}].lotno`} placeholder="Enter lot #" {...register(`animals[${index}].lotno`,
            {
              value: animal.lotno,
              required: true,
              maxLength: 30,
              validate: isUniqueLotNo
            })}/>
          {errors.animals && errors.animals.length > index && errors.animals[index] &&  errors.animals[index].lotno && (
            <div className={styles.error}>{errors.animals[index].lotno.type === "validate"? "Lot number should be unique" :"Lot number is required"}</div>
          )}
        </div>
      </div>

      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <div className={styles.label}>Purchase Price</div>
          <div className={styles.purchasePrice}>
            <span className={styles.symbol}>$</span>
            <input id={`animals[${index}].purchaseprice`} type="text" maxLength="10" placeholder="Enter price"
                  {...register(`animals[${index}].purchaseprice`,
            {
              value: animal.purchaseprice,
              required: {value: true, message: "Purchase price required"},
              validate: (val) => checkPrice(val),
              onChange: () => trigger(`animals[${index}].purchaseprice`)
            })}/>
          </div>
          {purchasePriceMessage && (
            <div className={styles.error}>{purchasePriceMessage}</div>
          )}
        </div>

        <div className={`${styles.buttons} ${styles.openFormButtons}`}>
          { ["FIRST", "NEW"].includes(itemStateRef.current) && <button type="button" className={styles.editButton} onClick={validateAndSave} disabled={Boolean(reviewMessage)}><FontAwesomeIcon icon={faEdit}/> Save</button> }
          { ["EDIT"].includes(itemStateRef.current) && <button type="button" className={styles.editButton} onClick={validateAndSave} disabled={Boolean(reviewMessage)}><FontAwesomeIcon icon={faEdit}/> Update</button> }
          { ["NEW","EDIT"].includes(itemStateRef.current) &&  <button type="button" className={styles.editButton} onClick={onDeleteClick}><FontAwesomeIcon icon={faTrash}/> Delete</button> }
        </div>
      </div>
    </fieldset>

  </div>
  );
}
